import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { Subject, BehaviorSubject } from 'rxjs';
@Injectable()
export class PWMUsersHttp {
  constructor(protected httpService: HttpService) {}
  getPwmMasterData = (reportType) => {
    return this.httpService.get(`/pwm-master-report/master-data?configType=${reportType}`);
  };

  filteredUserList = async (searchKey, listQuery) =>
    this.httpService.get(
      `/pwm-master-report/customers?&page=${listQuery.page}&size=${listQuery.size}&search=${searchKey}${
        (listQuery.sortField && '&sort=' + listQuery.sortField) || ''
      }`
    );

  filteredUserListCount = async (searchKey) => this.httpService.get(`/pwm-master-report/customers/count?search=${searchKey}`);

  filteredConfigurationList = async (searchKey, listQuery) =>
    this.httpService.get(
      `/pwm-master-report/pending-config-list?&page=${listQuery.page}&size=${listQuery.size}&search=${searchKey}${
        (listQuery.sortField && '&sort=' + listQuery.sortField) || ''
      }`
    );

  filteredConfigurationListCount = async (searchKey) => this.httpService.get(`/pwm-master-report/pending-config-list`);

  getPWMMasterReportConfig = async (customerId, status, type) => {
    return this.httpService.get(`/pwm-master-report/${customerId}/config/${status}?configType=${type}`);
  };

  getLatestEmailConfig = async (id) => {
    return this.httpService.get(`/pwm-master-report/latest-email-data/${id}`);
  };

  emailPwmReport = async (customerId, emailData) => {
    this.httpService.post(`/pwm-master-report/email-pwm-report/${customerId}`, emailData);
  };

  sendPWMCustomerConfigForApproval = async (data) => this.httpService.post(`/pwm-master-report/send-for-approval`, data);

  getCustomerListWithSameStructure = async (customerId) =>
    this.httpService.get(`/pwm-master-report/${customerId}/same-account-structure-customer-list`);

  getDownloadReportForCurrentConfig = async (format, token, configId) => {
    this.httpService.get(`/pwm-master-report/download-report?reportFormat=${format}&token=${token}&configId=${configId}`);
  };
  savePwmCustomerConfiguration = async (data, customerId) => this.httpService.post(`/pwm-master-report/${customerId}/save-config`, data);

  approveReportConfiguration = async (data) => this.httpService.post(`/pwm-master-report/approve`, data);

  loadAccountStructure = async (customerId) => this.httpService.get(`/pwm-master-report/${customerId}/account-structure`);

  loadCustomerbyId = async (customerId) => this.httpService.get(`/pwm-master-report/customer/${customerId}`);

  getBalanceStatement = async (crmCode, date) =>
    this.httpService.get(`/account/me/financial/portfolio/pwm/${crmCode}${date && '?date=' + date}`);
  getPortfolioBreakDown = async (crmCode, type, date) =>
    this.httpService.get(`/account/me/financial/portfolio/pwm/${crmCode}/detail?date=${date}&portfolioType=${type}`);

  getPortfolioSecondLevelBreakDown = async (crmCode, type, date, ids) =>
    this.httpService.get(`/account/me/financial/portfolio/pwm/${crmCode}/asset-detail?date=${date}&asset=${type}&portfolioIds=${ids}`);

  getBalanceSummary = async (crmCode, date) =>
    this.httpService.get(`/account/me/financial/portfolio/pwm/${crmCode}/summary${date && '?date=' + date}`);

  getSentReportDates = async (crmCode, withTypes) =>
    this.httpService.get(`/pwm-master-report/${crmCode}/previous-sent-reports${(withTypes && '?withTypes=' + withTypes) || ''}  `);

  downloadPreviousReports = async (historyId, token) =>
    this.httpService.get(`/pwm-master-report/download-previous-report?reportFormat=PDF&historyId=${historyId}&token=${token}`);

  syncPwmDataStructure = async (crmId) => this.httpService.get(`/manual-data-sync/sync-pwm-account-structure?crmCode=${crmId}`);
  getAssociatedPortfolios = async (id) => this.httpService.get(`/pwm-master-report/associated-portfolios/${id}`);
  modifyAssociatedPortfolios = async (id, portfolios) =>
    this.httpService.put(`/pwm-master-report/modify-associated-portfolios/${id}?portfolios=${portfolios}`);
}

@Injectable()
export class PWMUsersService {
  emitReportType$: Subject<any> = new BehaviorSubject<any>(null);
  constructor(protected http: PWMUsersHttp) {}
  emit(value: any) {
    this.emitReportType$.next(value);
  }
  get emitReportType(): BehaviorSubject<any> {
    return this.emitReportType$ as BehaviorSubject<any>;
  }
  async getPwmMasterData(reportType) {
    return await this.http.getPwmMasterData(reportType);
  }
  async filteredUserList(searchKey, listQuery) {
    return await this.http.filteredUserList(searchKey, listQuery);
  }
  async filteredUserListCount(searchKey) {
    return await this.http.filteredUserListCount(searchKey);
  }

  async filteredConfigurationList(customerId, status) {
    return await this.http.filteredConfigurationList(customerId, status);
  }
  async filteredConfigurationListCount(searchKey) {
    return await this.http.filteredConfigurationListCount(searchKey);
  }

  async emailPwmReport(customerId, data) {
    return await this.http.emailPwmReport(customerId, data);
  }

  async getMasterReportConfig(id, status, type) {
    return await this.http.getPWMMasterReportConfig(id, status, type);
  }

  async getCustomerListWithSameStructure(id) {
    return await this.http.getCustomerListWithSameStructure(id);
  }

  async sendPWMCustomerConfigForApproval(data) {
    return await this.http.sendPWMCustomerConfigForApproval(data);
  }

  async getDownloadReportForCurrentConfig(format, token, configId) {
    return await this.http.getDownloadReportForCurrentConfig(format, token, configId);
  }

  async loadAccountStructure(customerId) {
    return await this.http.loadAccountStructure(customerId);
  }

  async savePwmCustomerConfiguration(data, customerId) {
    return await this.http.savePwmCustomerConfiguration(data, customerId);
  }

  async approveReportConfiguration(data) {
    return await this.http.approveReportConfiguration(data);
  }

  async loadCustomerbyId(customerId) {
    return await this.http.loadCustomerbyId(customerId);
  }

  async getLatestEmailConfig(customerId) {
    return await this.http.getLatestEmailConfig(customerId);
  }

  async getBalanceStatement(crmCode, date = '') {
    return await this.http.getBalanceStatement(crmCode, date);
  }
  async getPortfolioBreakDown(crmCode, type, date) {
    return await this.http.getPortfolioBreakDown(crmCode, type, date);
  }
  async getPortfolioSecondLevelBreakDown(crmCode, type, date, ids) {
    return await this.http.getPortfolioSecondLevelBreakDown(crmCode, type, date, ids);
  }
  async getBalanceSummary(crmCode, date = '') {
    return await this.http.getBalanceSummary(crmCode, date);
  }

  async getSentReportDates(crmCode, withTypes?) {
    return await this.http.getSentReportDates(crmCode, withTypes);
  }

  async downloadPreviousReports(historyId, token) {
    return await this.http.downloadPreviousReports(historyId, token);
  }
  async syncPwmDataStructure(crmId) {
    return await this.http.syncPwmDataStructure(crmId);
  }
  async getAssociatedPortfolios(id) {
    return await this.http.getAssociatedPortfolios(id);
  }
  async modifyAssociatedPortfolios(id, portfolios) {
    return await this.http.modifyAssociatedPortfolios(id, portfolios);
  }
}
